import {CardSuperTable, DetailsSuperTable} from './SuperTable';
import HorizontalCardIconFactory from '../shared/HorizontalCardIconFactory';
import MicroIcon from '../shared/MicroIcon';
import Icon from 'components/Icon';

const Micro = MicroIcon(Icon.OPTIONS.SUMO);

export const card = CardSuperTable;
export const details = DetailsSuperTable;
export const micro = Micro;
export const icon = Micro;
export const horizontal = HorizontalCardIconFactory(Micro);
export const preview = CardSuperTable;
